export default "__VITE_ASSET__DnTM38HQ__"